import { useCallback, useEffect, useRef, useState } from 'react'
import { getCrossProjectWbsItemGanttColors } from '../../../../infrastructure/api/wbs-item-gantt-colors'
import { toColorMap } from '../../../containers/commons/AgGrid/components/cell/custom/gantt/CellRenderer/hooks/useWbsItemGanttColorData'
import { GanttBarColorName } from '../../../containers/commons/AgGrid/components/cell/custom/gantt/ganttUtil'
import {
  ProgramManagementRow,
  PROGRAM_MANAGEMENT_ROW_TYPE,
} from '../programManagement'

export const useProgramGanttColorData = (
  rows: ProgramManagementRow[]
): ReadonlyMap<string, GanttBarColorName> => {
  const [colors, setColors] = useState<ReadonlyMap<string, GanttBarColorName>>(
    new Map()
  )
  const fetchedForRef = useRef<string | null>(null)

  const fetchColors = useCallback(async () => {
    const projectUuids = rows
      .filter(r => r.type === PROGRAM_MANAGEMENT_ROW_TYPE.PROJECT)
      .map(r => r.projectUuid)
      .filter((projectUuid): projectUuid is string => !!projectUuid)

    if (projectUuids.length === 0) {
      fetchedForRef.current = null
      setColors(new Map())
      return
    }

    const key = projectUuids.sort().join(',')
    if (fetchedForRef.current === key) return
    fetchedForRef.current = key

    const response = await getCrossProjectWbsItemGanttColors(projectUuids)
    if (response.hasError) {
      fetchedForRef.current = null
      return
    }

    setColors(toColorMap(response.json ?? []))
  }, [rows])

  useEffect(() => {
    fetchColors()
  }, [fetchColors])

  return colors
}
